import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Line = _resolveComponent("Line")!

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock(_component_Line, {
        id: "line",
        data: _ctx.lineData,
        options: _ctx.lineOpts,
        key: _ctx.key
      }, null, 8, ["data", "options"]))
    : _createCommentVNode("", true)
}